
{
  "actions": {
    "enable": "Publish Page",
    "update": "Publish Updates"
  }
}
